[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 5,
                "y": 6,
                "key": "IplCh"
            },
            {
                "x": 5,
                "y": 3,
                "key": "tLpRoiW2EvVrLyND4pBYF"
            },
            {
                "x": 7,
                "y": 3,
                "key": "6B2Jm"
            },
            {
                "x": 7,
                "y": 2,
                "key": "9sCZG"
            },
            {
                "x": 9,
                "y": 2,
                "key": "ubLeG"
            },
            {
                "x": 9,
                "y": 3,
                "key": "MIYRm"
            },
            {
                "x": 10,
                "y": 3,
                "key": "7gTwWqlCkIq9wxOI9wDMl"
            },
            {
                "x": 10,
                "y": 4,
                "key": "ywLl2"
            },
            {
                "x": 10,
                "y": 5,
                "key": "X54_T"
            },
            {
                "x": 11,
                "y": 5,
                "key": "Nq-FG"
            },
            {
                "x": 11,
                "y": 7,
                "key": "z9Nn61pWmpd489F0Co-yj"
            },
            {
                "x": 9,
                "y": 7,
                "key": "486an"
            },
            {
                "x": 6,
                "y": 7,
                "key": "qg0NO"
            },
            {
                "x": 6,
                "y": 6,
                "key": "stOEn_4Hof8z7g2cDFKPY"
            }
        ]
    }
]